<template>
  <slotted-edit-list-item :label="label"
                          :value="value"
                          :edit="edit"
                          :liclass="liclass"
                          :compact="compact"
                          :noempty="noempty">

    <template v-slot:normalmodecontent>
      <slot name="normalmodecontent">
        <v-list-item-content class="py-0"
                             @mouseenter="expandonhover ? (hoverexpanded = true) : null"
                             @mouseleave="expandonhover ? (hoverexpanded = false) : null">
          <div class="d-flex">
            <normal-mode-template :label="label"
                                  :compact="compact"
                                  :noempty="noempty"
                                  :loading="loading">
              <template v-slot:value>
                <slot name="value">
                  <v-list-item-title v-html="displayString"
                                     ref="normalmodetextfield"
                                     class="valuetext pl-3 pr-0 pb-2"
                                     :class="[loading ? 'blurred':'', showFullText ? '' : 'nowrapheader', valueWillOverflow ? '' : 'pr-3', (valuecolor ? (valuecolor + '--text') : ''), ]" />
                </slot>
              </template>
            </normal-mode-template>
            <v-btn v-if="value && valueWillOverflow && expandonhover != null"
                   :style="'margin-top: ' + (compact ? (hoverexpanded ? '2' : '-2') : '20') + 'px !important;'"
                   icon
                   small
                   :color="expanded ? 'primary' : (hoverexpanded ? 'tertiary': '')"
                   @click="expanded = !expanded">
              <v-icon v-text="expanded ? 'mdi-arrow-collapse-vertical' : 'mdi-arrow-expand-vertical'"
                      size="20" />
            </v-btn>
          </div>
        </v-list-item-content>
        <empty-value-warning :value="value"
                             :noempty="noempty"
                             :loading="loading">
        </empty-value-warning>
      </slot>
    </template>

    <template v-slot:editmodecontent>
      <v-list-item-content class="py-0 pt-3">
        <v-textarea v-model="editValue"
                    :label="noempty ? label + '*' : label"
                    :rules="rule"
                    ref="textarea"
                    @keydown.enter.exact="timestamp ? newline($event) : null"
                    rows="1"
                    auto-grow
                    outlined
                    dense
                    hide-details="auto" />
      </v-list-item-content>
    </template>
  </slotted-edit-list-item>
</template>


<script>
import rules from "@/helpers/Mixins/RuleMixin.js";
import SlottedEditListItem from "@/components/Inputs/Parts/SlottedEditListItem.vue";
import NormalModeTemplate from "@/components/Inputs/Parts/NormalModeTemplate.vue";
import EmptyValueWarning from "@/components/Inputs/Parts/EmptyValueWarning.vue";

export default {
  name: "AreaListItem",
  props: [
    "label",
    "keyname",
    "value",
    "edit",
    "noempty",
    "onlyedit",
    "timestamp",
    "compact",
    "valuecolor",
    "expandonhover",
    "loading",
    "liclass",
    "searchterm",
  ],
  components: { SlottedEditListItem, NormalModeTemplate, EmptyValueWarning },
  mixins: [rules],

  data: () => ({
    isMounted: false,
    editValue: null,
    emitStack: [],
    expanded: false,
    hoverexpanded: false,
  }),

  mounted() {
    this.isMounted = true;
    this.editValue = this.value;
    if (this.expandonhover == null) {
      this.hoverexpanded = true;
    }
    this.emitValue();
  },

  methods: {
    emitValue() {
      this.$emit("fetch", { key: this.keyname, value: this.editValue });
    },

    newline(e) {
      const textarea = this.$refs.textarea.$refs.input;
      const existingtext = textarea.value;
      const indexOfFirstNewLine = existingtext.indexOf("\n");
      let cursorIndex = textarea.selectionStart ? textarea.selectionStart : 0;

      if (indexOfFirstNewLine < 0 || cursorIndex <= indexOfFirstNewLine) {
        e.preventDefault();
        var insertText = this.getUserTimestamp();
        this.editValue = insertText + existingtext;
        this.$nextTick().then(() => {
          textarea.selectionStart = cursorIndex + insertText.length;
          textarea.selectionEnd = cursorIndex + insertText.length;
        });
      }
    },
  },

  computed: {
    rule() {
      if (this.noempty) {
        return this.noEmptyRule;
      } else {
        return [];
      }
    },

    newLinedString() {
      if (this.value) {
        if (this.expanded || (this.hoverexpanded && (typeof this.value === "string" || this.value instanceof String))) {
          return this.value.replace(/(?:\r\n|\r|\n)/g, "<br>");
        } else {
          return this.value;
        }
      } else {
        return null;
      }
    },

    displayString() {
      if (this.searchterm) {
        return this.searchhighlight(this.newLinedString, this.searchterm, true);
      } else {
        return this.newLinedString;
      }
    },

    showFullText() {
      if (this.expanded || this.hoverexpanded) {
        return true;
      } else {
        return false;
      }
    },

    valueWillOverflow() {
      if (this.isMounted) {
        var field = this.$refs.normalmodetextfield;
        if (field) {
          return field.offsetWidth < field.scrollWidth;
        }
      }
      return false;
    },
  },

  watch: {
    //Set initial value
    value: function () {
      this.editValue = this.value;
    },
    //Ques emit of edited value on change
    editValue: function () {
      this.emitValue();
    },
  },
};
</script>

<style lang="scss" scoped>
.error--text {
  margin-bottom: -8px !important;
}
.valuetext {
  font-size: 13px !important;
  white-space: normal;
  width: 50px;
}
</style>